'use client';

import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

import Icon from '../Icon/Icon';
import { useFusionTheme } from '../hooks';

import styles from './Tag.module.scss';

const tagVariants = cva(styles.tag, {
  variants: {
    variant: {
      primary: styles.variantPrimary,
      black: styles.variantBlack,
      brandRed: styles.variantBrandRed,
      white: styles.variantWhite,
      blue: styles.variantBlue,
      red: styles.variantRed,
      green: styles.variantGreen,
      yellow: styles.variantYellow,
      purple: styles.variantPurple,
      orange: styles.variantOrange,
      magenta: styles.variantMagenta,
      neutral: styles.variantNeutral,
      neutralDark: styles.variantNeutralDark
    },
    size: {
      small: styles.sizeSmall,
      default: styles.sizeDefault
    }
  }
});

type TagVariants = VariantProps<typeof tagVariants>;

export type TagProps = TagVariants & {
  'aria-label'?: string;
  'aria-labelledby'?: string;
  icon?: React.FC<React.SVGProps<SVGElement>>;
  text: string;
  className?: string;
};

export function Tag({
  variant = 'primary',
  size = 'default',
  className,
  text,
  icon,
  ...props
}: TagProps) {
  const { addThemeClassName } = useFusionTheme();

  return (
    <span className={addThemeClassName(tagVariants({ variant, size, className }))} {...props}>
      {icon && <Icon size="sm" icon={icon} aria-hidden />}
      {text}
    </span>
  );
}

export default Tag;
